import styled from 'styled-components';
import PropTypes from 'prop-types';
import themeColors from '../assets/styles/themeColors';

const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ color }) => color || themeColors.colorsDivider};
`;

const VerticalLine = styled(HorizontalLine)`
  width: 1px;
  height: 100%;
`;

const LineHolderHorizontal = styled.div`
  width: 100%;
  height: ${({ height }) => height};
  display: flex;
  align-items: center;
`;

const LineHolderVertical = styled(LineHolderHorizontal)`
  width: ${({ width }) => width};
  height: 100%;
  justify-content: center;
`;

const Divider = ({ vertical, horizontal, width, height, color }) => (
  <>
    {vertical && (
      <LineHolderVertical width={width}>
        <VerticalLine color={color} />
      </LineHolderVertical>
    )}
    {horizontal && (
      <LineHolderHorizontal height={height}>
        <HorizontalLine color={color} />
      </LineHolderHorizontal>
    )}
  </>
);

Divider.propTypes = {
  vertical: PropTypes.bool,
  horizontal: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

Divider.defaultProps = {
  vertical: false,
  horizontal: true,
  height: '15px',
};

export default Divider;
